
// import MostrarVentana from './MostrarVentana';
import ActionTypePrincipal from '../ActionTypePrincipal'


// export default class CargarYMostrarVentana extends MostrarVentana {
export default class CrearYMostrarVentana extends ActionTypePrincipal{
    
    ejecutar(state, nuevoEstado){
        const ventanaAAbrir = this.payload;
        ventanaAAbrir.posicionZ = state.ventanas.length + 1;
        nuevoEstado.ventanas.push(ventanaAAbrir);
        return nuevoEstado;
    }
}